"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationListSortBy = exports.testIds = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const frontend_infra_localisation_1 = require("@forto-dev/frontend-infra-localisation");
const silhouette_core_1 = require("@freighthub/silhouette-core");
const useNotificationListState_1 = require("../hooks/useNotificationListState");
const sortOptions = ['createdAt', 'typePriority'];
exports.testIds = {
    sortByDropdown: 'notification_list-filters-sort_by_dropdown',
};
const NotificationListSortBy = () => {
    const { translate } = (0, frontend_infra_localisation_1.useI18n)();
    const { sortBy, setSortBy } = (0, useNotificationListState_1.useNotificationListState)();
    const selectedSortBy = sortBy || sortOptions[0];
    const getOptionItem = (item) => {
        return { value: item, label: translate(`notification_list-sort-${item}`) };
    };
    return ((0, jsx_runtime_1.jsx)(silhouette_core_1.DropdownChip, { "data-testid": exports.testIds.sortByDropdown, "data-tracking-id": "notification_list-sort_by-dropdown", selectedOption: getOptionItem(selectedSortBy), onOptionSelect: ({ value }) => setSortBy(value), options: sortOptions.map((option) => getOptionItem(option)) }));
};
exports.NotificationListSortBy = NotificationListSortBy;
//# sourceMappingURL=NotificationListSortBy.js.map